import { hslToRgb } from "utils/hslToRgb";
import type { GenerateRandomRgbColor } from "./types";

export const generateRandomRgbColor: GenerateRandomRgbColor = () => {
  const hue = Math.random() * 360;
  const saturation = 0.75;
  const lightness = 0.5;

  return hslToRgb({ hue, saturation, lightness });
};
